import React from 'react';
import {StaticVideoSlideComponent} from '../../../components/video-slides/components/static-video-slide/static-video-slide.component';
import {SlideBaseRenderer} from './slide-base.renderer';
import {GameInfo} from "../../games/game-info";

export class GameStaticVideoSlideRenderer extends SlideBaseRenderer {
    constructor(private readonly gameInfo: GameInfo,
                private readonly isStaticVideoFromCdnPOC?: boolean) { //TODO - remove isStaticVideoFromCdnPOC this if it is for POC
        super();
    }

    get uniqueKey(): string {
        return this.gameInfo.gameType.toString();
    }

    render(): React.ReactElement {
        return (<StaticVideoSlideComponent key={this.uniqueKey} gameInfo={this.gameInfo} isStaticVideoFromCdnPOC={this.isStaticVideoFromCdnPOC}/>);
    }
}
